/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Newpatient_Newform2Inputs */

const en_newpatient_newform2 = /** @type {(inputs: Newpatient_Newform2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New form`)
};

const fr_newpatient_newform2 = /** @type {(inputs: Newpatient_Newform2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau formulaire`)
};

/**
* | output |
* | --- |
* | "New form" |
*
* @param {Newpatient_Newform2Inputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
const newpatient_newform2 = /** @type {((inputs?: Newpatient_Newform2Inputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Newpatient_Newform2Inputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_newpatient_newform2(inputs)
	return fr_newpatient_newform2(inputs)
});
export { newpatient_newform2 as "newPatient_newForm" }